import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ChangePasswordModal from '../components/ChangePasswordModal';

const UrBetSettingPage = () => {
  const navigate = useNavigate();
  const [isPasswordModalOpen, setIsPasswordModalOpen] = React.useState(false);
  
  // Get user from Redux store
  const user = useSelector(function(state) {
    return state.auth?.user;
  });

  // Card navigation handler
  const handleNavigation = function(path) {
    if (path) {
      navigate(path);
    }
  };

  // Card data
  const cards = [
    {
      title: 'Search User',
      path: '/settings/user-search',
    },
    {
      title: 'Statements',
      path: '/settings/statement-report',
    },
    {
      title: 'A/c operations',
      path: user ? '/settings/account-operations/' + user.userId : '/settings/account-operations/default',
    },
    {
      title: 'Profit & Loss',
      path: '/ledger/profit-loss',
    },
    {
      title: 'Casino Profit & Loss',
      path: '/settings/casino-profit-loss',
    },
    {
      title: 'Change Password',
      path: null,
      onClick: function() { setIsPasswordModalOpen(true); }
    },
  ];

  return (
    <main className="w-full bg-gray-100 min-h-screen">
      <div className="bg-white rounded border border-gray-300 shadow-sm">
        <div className="p-1">
          {/* Cards Grid - Responsive */}
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-6 sm:gap-6 mb-4 auto-rows-fr">
            {cards.map(function(card, index) {
              return (
                <div key={index} className="h-full">
                  {card.path ? (
                    <a
                      href={card.path}
                      onClick={function(e) {
                        e.preventDefault();
                        handleNavigation(card.path);
                      }}
                      className="block h-full min-h-[72px] sm:min-h-0 bg-[#0F2327] hover:bg-[#1a3439] text-white p-4 sm:p-4 rounded text-center cursor-pointer font-normal text-md sm:text-sm md:text-base transition-all duration-300 border border-[#0a1a1d] flex items-center justify-center"
                    >
                      {card.title}
                    </a>
                  ) : (
                    <div 
                      onClick={card.onClick}
                      className="block h-full min-h-[72px] sm:min-h-0 bg-[#0F2327] hover:bg-[#1a3439] text-white p-4 sm:p-4 rounded text-center cursor-pointer font-normal text-md sm:text-sm md:text-base border border-[#0a1a1d] transition-all duration-300 flex items-center justify-center"
                    >
                      {card.title}
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          {/* Table - Responsive with horizontal scroll */}
          <div className="overflow-x-auto">
            <div className="inline-block min-w-full align-middle">
              <div className="overflow-hidden border border-gray-300">
                <table className="min-w-full border-collapse">
                  <thead className="bg-[#0F2327]">
                    <tr>
                      <th className="px-3 py-3 text-left text-white font-medium text-xs sm:text-sm border border-[#0a1a1d] whitespace-nowrap">
                        Title
                      </th>
                      <th className="px-3 py-3 text-left text-white font-medium text-xs sm:text-sm border border-[#0a1a1d] whitespace-nowrap">
                        Sport
                      </th>
                      <th className="px-3 py-3 text-left text-white font-medium text-xs sm:text-sm border border-[#0a1a1d] whitespace-nowrap">
                        Open Date
                      </th>
                      <th className="px-3 py-3 text-left text-white font-medium text-xs sm:text-sm border border-[#0a1a1d] whitespace-nowrap">
                        Declared
                      </th>
                      <th className="px-3 py-3 text-left text-white font-medium text-xs sm:text-sm border border-[#0a1a1d] whitespace-nowrap">
                        Won By
                      </th>
                      <th className="px-3 py-3 text-left text-white font-medium text-xs sm:text-sm border border-[#0a1a1d] whitespace-nowrap">
                        Profit/Loss
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white">
                    <tr>
                      <td colSpan="6" className="px-4 py-12 sm:py-16 text-center border border-gray-300">
                        <div className="flex flex-col items-center justify-center">
                          <svg 
                            width="64" 
                            height="41" 
                            viewBox="0 0 64 41" 
                            xmlns="http://www.w3.org/2000/svg"
                            className="mb-2"
                          >
                            <g transform="translate(0 1)" fill="none" fillRule="evenodd">
                              <ellipse fill="#f5f5f5" cx="32" cy="33" rx="32" ry="7"></ellipse>
                              <g fillRule="nonzero" stroke="#d9d9d9">
                                <path d="M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"></path>
                                <path d="M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z" fill="#fafafa"></path>
                              </g>
                            </g>
                          </svg>
                          <div className="text-gray-400 text-sm">
                            No data
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Change Password Modal */}
      <ChangePasswordModal 
        isOpen={isPasswordModalOpen}
        onClose={function() { setIsPasswordModalOpen(false); }}
      />
    </main>
  );
};

export default UrBetSettingPage;
